export * from './UserIcon';

import UserIcon from './UserIcon';
export default UserIcon;
